import { TruncatePipe } from './Pipes/truncate.pipe';
import { TutorialService } from './Services/tutorial.service';
import { SortByLastnamePipe } from './Pipes/sortByLastname.pipe';
import { LOCALE_ID } from '@angular/core';
import { ActivityService } from './Services/activity.service';
import { ActivityTrackerListComponent } from './components/activity-tracker-list/activity-tracker-list.component';
import { ActivityTrackerFormComponent } from './components/activity-tracker-form/activity-tracker-form.component';
import { RoundPipe } from './Pipes/round.pipe';
import { NewlineToHtmlPipe } from './Pipes/newlineToHtml.pipe';

import { SponsorService } from './Services/sponsor.service';
import { SponsorListComponent } from './components/sponsor-list/sponsor-list.component';
import { TourService } from './Services/tour.service';
import { SafePipe } from './Pipes/safe.pipe';
import { ArrivalService } from './Services/arrival.service';
import { DepartTimeFormComponent } from './components/depart-time-form/depart-time-form.component';
import { ArrivalListComponent } from './components/arrival-list/arrival-list.component';
import { MeerdaagseFormComponent } from './components/meerdaagse-form/meerdaagse-form.component';
import { MeerdaagseListComponent } from './components/meerdaagse-list/meerdaagse-list.component';
import { EvenementFormComponent } from './components/evenement-form/evenement-form.component';
import { GeneralSettingsService } from './Services/general-settings.service';
import { PloegInfoComponent } from './components/ploeginfo/ploeginfo.component';
import { AlertComponent } from './components/alerts/alert.component';
import { LoadingAnimationComponent } from './components/loading/loading.components';
import { HeaderBarComponent } from './components/header-bar/header-bar.component';
import { StaticPageService } from './Services/static-page.service';
import { StaticPageComponent } from './components/static-page/static-page.component';
import { AuthGuard } from './Services/auth-guard.service';
import { NoSpacePipe } from './Pipes/nospace.pipe';
import { CalendarFormComponent } from './components/calendar-form/calendar-form.component';
import { CalendarService } from './Services/calendar.service';
import { CalendarCreatorFormComponent } from './components/calendar-creator-form/calendar-creator-form.component';
import { CourseFormComponent } from './components/course-form/course-form.component';
import { CourseService } from './Services/course.service';
import { CourseListComponent } from './components/course-list/course-list.component';
import { GroupFormComponent } from './components/group-form/group-form.component';
import { GroupService } from './Services/group.service';
import { MemberService } from './Services/member.service';
import { NgModule, ErrorHandler } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule } from '@angular/router';

import { AppComponent } from './components/app/app.component';
import { NavMenuComponent } from './components/navmenu/navmenu.component';
import { HomeComponent } from './components/home/home.component';

import { MemberFormComponent } from './components/member-form/member-form.component';
import { MemberListComponent } from './components/member-list/member-list.component';
import { GroupListComponent } from './components/group-list/group-list.component';
import { CourseriddenListComponent } from './components/courseridden-list/courseridden-list.component';
import { ToastyModule } from 'ng2-toasty';
import { QuillModule } from 'ngx-quill';


import { AppErrorHandler } from './app.error-handler';
import { CourseriddenService } from './Services/courseridden.service';
import { CourseriddenFormComponent } from './components/courseridden-form/courseridden-form.component';
import { AuthService } from './Services/auth.service';
import { RoleAuthGuard } from './Services/role-guard.service';
import { AUTH_PROVIDERS } from 'angular2-jwt';
import { FooterBarComponent } from './components/footer-bar/footer-bar.components';
import { CourseriddenUserListComponent } from './components/courseridden-user-list/courseridden-user-list.component';
import { SingleMemberComponent } from './components/singleMember-form/singlemember.component';
import { AlertService } from './Services/alert.service';
import { AdminSettingsFormComponent } from './components/admin-settings-form/admin-settings-form.component';
import { EventService } from './Services/event.service';
import { DepartTimeService } from './Services/depart-time.service';
import { ShowTimeOnlyPipe } from './Pipes/showTimeOnly.pipe';
import { AgendaFormComponent } from './components/agenda-form/agenda-form.component';
import { AgendaService } from './Services/agenda.service';
import { EvenementListComponent } from './components/evenement-list/evenement-list.component';
import { TourFormComponent } from './components/tour-form/tour-form.component';
import { YearOverviewComponent } from './components/year-overview/year-overview.component';
import { MyDatePickerModule } from 'mydatepicker';
import { FrontpageService } from './Services/frontpage.service';
import { UploadService } from './Services/upload.service';
import { HomeCardShowComponent } from './components/home-card-show/home-card-show.component';
import { HomeCardEditComponent } from './components/home-card-edit/home-card-edit.component';
import { SafeHtmlPipe } from './Pipes/safeHtml.pipe';
import { HomeCardCenterShowComponent } from './components/home-card-center-show/home-card-center-show.component';
import { DocumentMemberFormComponent } from './components/document-member-form/document-member-form.component';
import { DocumentAdminFormComponent } from './components/document-admin-form/document-admin-form.component';
import { DocumentService } from './Services/document.service';
import { AmountRiddenPerGroupComponent } from './components/amount-ridden-per-group/amount-ridden-per-group.component';
import { SubscriptionCreateListComponent } from './components/subscription-create-list/subscription-create-list.component';
import { SubscriptionService } from './Services/subscription.service';
import { SocialMediaComponent } from './components/social-media/social-media.component';
import { SubscriptionEditMemberComponent } from './components/subscription-list-member-edit/subscription-list-member-edit.component';
import { SubscriptionActivitiesMemberComponent } from './components/subscription-activities-member/subscription-activities-member.component';
import { NewMemberFormComponent } from './components/new-member-form/new-member-form.component';
import { NewMemberFormAdminComponent } from './components/new-member-form-admin/new-member-form-admin.component';
import { GeneralMemberInformationComponent } from './components/general-member-information/general-member-information.component';
import { AnnouncementShowComponent } from './components/announcement-show/announcement-show.component';
import { AnnouncementService } from './Services/announcement.service';
import { TutorialListComponent } from './components/tutorial-list/tutorial-list.component';
import { TuturialEditComponent } from './components/tuturial-edit/tuturial-edit.component';
import { MemberDiscountFormComponent } from './components/member-discount-form/member-discount-form.component';
import { MemberDiscountListComponent }from './components/member-discount-list/member-discount-list.component';
import { DiscountService } from './Services/discount.service';
import { ClothesAdminFormComponent } from './components/clothes-admin-form/clothes-admin-form.component';
import { ClothesAdminListComponent } from './components/clothes-admin-list/clothes-admin-list.component';
import { OrderFormComponent } from './components/order-from/order-form.component';
import { ClothesService } from './Services/clothes.service';
import { OrderService } from './Services/order.service';
import { OrderListComponent } from './components/order-list/order-list.component';
import { OrderListMemberComponent } from './components/order-list-member/order-list-member.component';
import { ModuleService } from './Services/modules.service';
import { StockService } from './Services/stock.service';
import { StockComponent } from './components/stock/stock.component';
import { StockImportComponent } from './components/stock-import/stock-import.component';
import { CourseCommentFormComponent } from './components/course-comment-form/course-comment-form.component';
import { MembercardCheckerComponent } from './components/membercard-checker/membercard-checker.component';
import { PreviewTrackComponent } from './components/preview-track/preview-track.component';
import { MemberMassPayedComponent } from './components/member-mass-payed/member-mass-payed.component';
import { MemberInformationComponent } from './components/member-information/member-information.component';
import { CourseViewComponent } from './components/course-view/course-view.component';
import { MemberFaqComponent } from './components/member-faq/member-faq.component';
import { SubscriptionNonMemberComponent } from './components/subscription-non-member/subscription-non-member.component';
import { SubscriptionNonMemberAdminComponent } from './components/subscription-non-member-admin/subscription-non-member-admin.component';
import { NonMemberActivityService } from './Services/nonMemberActivity.service';
import { SubscriptionListNonMemberComponent } from './components/subscription-list-non-member-edit/subscription-list-non-member-edit.component';
import { PaymentService } from './Services/payment.service';
import { PaymentRedirectComponent } from './components/payment-redirect/payment-redirect.component';
import { PaymentProcessingComponent } from './components/payment-processing/payment-processing.component';
import { VolunteerSubscriptionFormComponent } from './components/volunteer-subscription-form/volunteer-subscription-form.component';
import { VolunteerSubscriptionAdminComponent } from './components/volunteer-subscription-admin/volunteer-subscription-admin.component';
import { VolunteerSubscriptionListComponent } from './components/volunteer-subscription-list/volunteer-subscription-list.component';
import { VolunteerSubsriptionService } from './Services/volunteerSubscription.service';
import { VolunteerSubscriptionListMembersComponent } from './components/volunteer-subscription-list-members/volunteer-subscription-list-members.component';
import { GroupBudgetViewComponent } from './components/group-budget-view/group-budget-view.component';
import { MemberPerksListComponent } from './components/member-perks-list/member-perks-list.component';
import { MemberPerksAdminComponent } from './components/member-perks-admin/member-perks-admin.component';
import { MemberWhatsAppCommunityComponent } from './components/member-whatsapp-community/member-whatsapp-community';

import { GroupBudgetService } from './Services/groupBudget.service';
import { memberPerkService } from './Services/memberPerk.service';




@NgModule({
    declarations: [
        AppComponent,
        NavMenuComponent,
        HomeComponent,
        MemberFormComponent,
        MemberListComponent,
        GroupListComponent,
        GroupFormComponent,
        GroupBudgetViewComponent,
        CourseListComponent,
        CourseFormComponent,
        CourseViewComponent,
        CourseriddenListComponent,
        CourseriddenFormComponent,
        CalendarCreatorFormComponent,
        CalendarFormComponent,
        NoSpacePipe,
        ShowTimeOnlyPipe,
        SafePipe,
        SafeHtmlPipe,
        RoundPipe,     
        NewlineToHtmlPipe,
        TruncatePipe,
        SortByLastnamePipe,  
        FooterBarComponent,
        HeaderBarComponent,
        StaticPageComponent,
        CourseriddenUserListComponent,
        LoadingAnimationComponent,
        SingleMemberComponent,
        AlertComponent,
        PloegInfoComponent,
        AdminSettingsFormComponent,
        EvenementFormComponent,
        MeerdaagseListComponent,
        MeerdaagseFormComponent,
        ArrivalListComponent,
        DepartTimeFormComponent,
        AgendaFormComponent,
        EvenementListComponent,
        TourFormComponent,
        SponsorListComponent,
        YearOverviewComponent,
        ActivityTrackerFormComponent,
        ActivityTrackerListComponent,
        HomeCardShowComponent,
        HomeCardEditComponent,
        HomeCardCenterShowComponent,
        DocumentMemberFormComponent,
        DocumentAdminFormComponent,
        AmountRiddenPerGroupComponent,
        SubscriptionCreateListComponent,
        SocialMediaComponent,
        SubscriptionEditMemberComponent,
        SubscriptionActivitiesMemberComponent,
        NewMemberFormComponent,
        NewMemberFormAdminComponent,
        GeneralMemberInformationComponent,
        AnnouncementShowComponent,
        TutorialListComponent,
        TuturialEditComponent,
        MemberDiscountFormComponent,
        MemberDiscountListComponent,
        MemberFaqComponent,
        ClothesAdminFormComponent,
        ClothesAdminListComponent,
        OrderFormComponent,
        OrderListComponent,
        OrderListMemberComponent,
        StockComponent,
        StockImportComponent,
        CourseCommentFormComponent,
        MembercardCheckerComponent,
        PreviewTrackComponent,
        MemberMassPayedComponent,
        MemberInformationComponent,
        SubscriptionNonMemberComponent,
        SubscriptionNonMemberAdminComponent,
        SubscriptionListNonMemberComponent,
        PaymentRedirectComponent,
        PaymentProcessingComponent,
        VolunteerSubscriptionFormComponent,
        VolunteerSubscriptionAdminComponent,
        VolunteerSubscriptionListComponent,
        VolunteerSubscriptionListMembersComponent,
        MemberPerksListComponent,
        MemberPerksAdminComponent,
        MemberWhatsAppCommunityComponent
    ],
    imports: [
    
    CommonModule,
        HttpModule,
        FormsModule,
        QuillModule,
        ToastyModule.forRoot(),
        RouterModule.forRoot([
            { path: '', redirectTo: 'home', pathMatch: 'full' },

            { path: 'members/new', component: MemberFormComponent, canActivate: [RoleAuthGuard], data: { requiredRoles: ['admin'] } },
            { path: 'members/list', component: MemberListComponent, canActivate: [RoleAuthGuard], data: { requiredRoles: ['admin'] } },
            { path: 'members/massedit', component: MemberMassPayedComponent, canActivate: [RoleAuthGuard], data: { requiredRoles: ['admin'] } },
            { path: 'members/information', component: MemberInformationComponent, canActivate: [RoleAuthGuard], data:{membersOnly:['true']} },        
            

            { path: 'members/perks', component: MemberPerksListComponent, canActivate: [RoleAuthGuard], data:{membersOnly:['true']} },        
            { path: 'members/perks/admin', component: MemberPerksAdminComponent, canActivate: [RoleAuthGuard], data:{requiredRoles: ['admin']} },  
            { path: 'members/whatsappcommunity', component: MemberWhatsAppCommunityComponent, canActivate: [RoleAuthGuard], data:{membersOnly:['true']} },        
                  
            
            { path: 'members/:id', component: MemberFormComponent, canActivate: [RoleAuthGuard], data: { requiredRoles: ['admin'] } },
            { path: 'members/ownerdata/:id', component: SingleMemberComponent, canActivate: [RoleAuthGuard], data:{membersOnly:['true']} },
            

            { path: 'groups/new', component: GroupFormComponent, canActivate: [RoleAuthGuard], data: { requiredRoles: ['admin'] } },
            { path: 'groups/list', component: GroupListComponent, canActivate: [RoleAuthGuard], data: { requiredRoles: ['admin'] } },
            { path: 'groups/budget', component: GroupBudgetViewComponent, canActivate: [RoleAuthGuard], data: { requiredRoles: ['admin','baankapitein'] } },
            { path: 'groups/:id', component: GroupFormComponent, canActivate: [RoleAuthGuard], data: { requiredRoles: ['admin'] } },

            

            
            { path: 'discounts/list', component: MemberDiscountListComponent, canActivate: [RoleAuthGuard], data: { requiredRoles: ['admin'] } },
            { path: 'discounts/new', component: MemberDiscountFormComponent, canActivate: [RoleAuthGuard], data: { requiredRoles: ['admin'] } },
            { path: 'discounts/:id', component: MemberDiscountFormComponent, canActivate: [RoleAuthGuard], data: { requiredRoles: ['admin'] } },

            { path: 'courses/new', component: CourseFormComponent, canActivate: [RoleAuthGuard], data: { requiredRoles: ['admin', 'CourseEditor'] } },
            { path: 'courses/list', component: CourseListComponent },
            { path: 'courses/view/:id', component: CourseViewComponent },
            { path: 'courses/:id', component: CourseFormComponent, canActivate: [RoleAuthGuard], data: { requiredRoles: ['admin','CourseEditor'] } },
            
            { path: 'comments/:id', component: CourseCommentFormComponent, canActivate: [RoleAuthGuard], data: { requiredRoles: ['admin','CourseEditor', 'baankapitein'] } },
            

            { path: 'coursesridden/list', component: CourseriddenListComponent, canActivate: [RoleAuthGuard], data: { requiredRoles: ['admin', 'baankapitein'] } },
            { path: 'coursesridden/user/:id', component: CourseriddenUserListComponent, canActivate: [RoleAuthGuard], data:{membersOnly:['true']} },
            { path: 'coursesridden/group', component: AmountRiddenPerGroupComponent,canActivate: [RoleAuthGuard], data: { requiredRoles: ['admin', 'baankapitein'] } },
            { path: 'coursesridden/:id', component: CourseriddenFormComponent,canActivate: [RoleAuthGuard], data: { requiredRoles: ['admin', 'baankapitein']} },

            { path: 'calendar/creator', component: CalendarCreatorFormComponent, canActivate: [RoleAuthGuard], data: { requiredRoles: ['admin', 'baankapitein'] } },
            { path: 'calendar', component: CalendarFormComponent },

            { path: 'meerdaagse/new', component: MeerdaagseFormComponent },
            { path: 'meerdaagse/:id', component: MeerdaagseFormComponent },
            { path: 'meerdaagselist/:id', component: MeerdaagseListComponent },

            { path: 'adminstuff', component: AdminSettingsFormComponent, canActivate: [RoleAuthGuard], data: { requiredRoles: ['admin'] } },
            { path: 'yearoverview', component: YearOverviewComponent, canActivate: [RoleAuthGuard], data: { requiredRoles: ['admin'] } },

            { path: 'evenement/new', component: EvenementFormComponent },
            { path: 'evenement/:id', component: EvenementFormComponent },
            { path: 'evenementList/:id', component: EvenementListComponent },

            { path: 'home', component: HomeComponent },
            { path: 'ploeginfo', component: PloegInfoComponent },
            { path: 'sponsor', component: SponsorListComponent },
            { path: 'faq', component: MemberFaqComponent },
            { path: 'static/:page', component: StaticPageComponent },
            
           
            
            { path: 'lidmaatschap', component:GeneralMemberInformationComponent},

            { path: 'activity/new', component: ActivityTrackerFormComponent },
            { path: 'activity/list', component: ActivityTrackerListComponent },
            { path: 'activity/:id', component: ActivityTrackerFormComponent },

            { path: 'frontpage/new', component: HomeCardEditComponent, canActivate: [RoleAuthGuard], data: { requiredRoles: ['admin','editor'] } },
            { path: 'frontpage/edit/:id', component: HomeCardEditComponent, canActivate: [RoleAuthGuard], data: { requiredRoles: ['admin','editor'] }  },
            
            { path: 'documents/member/:id', component: DocumentMemberFormComponent },
            { path: 'documents/admin', component: DocumentAdminFormComponent, canActivate: [RoleAuthGuard], data:{requiredRoles: ['admin']} },

            { path: 'subscription/subscribe/:id', component: SubscriptionActivitiesMemberComponent },
            { path: 'subscription/list', component: SubscriptionCreateListComponent,canActivate: [RoleAuthGuard], data:{requiredRoles: ['admin']}  },
            { path: 'subscription/members/:id', component: SubscriptionEditMemberComponent,canActivate: [RoleAuthGuard], data:{requiredRoles: ['admin']}  },
            
            { path: 'subscription/nonmembers/admin', component: SubscriptionNonMemberAdminComponent },            
            { path: 'subscription/nonmembers/:id', component: SubscriptionNonMemberComponent },
            { path: 'subscription/nonmembers/list/:id', component: SubscriptionListNonMemberComponent },

            { path: 'subscription/volunteers/admin', component: VolunteerSubscriptionAdminComponent,canActivate: [RoleAuthGuard], data:{requiredRoles: ['admin']} },
            { path: 'subscription/volunteers/list/member', component: VolunteerSubscriptionListMembersComponent, canActivate: [RoleAuthGuard], data:{membersOnly:['true']}},
            { path: 'subscription/volunteers/list/:id', component: VolunteerSubscriptionListComponent },
            { path: 'subscription/volunteers/:id', component: VolunteerSubscriptionFormComponent },
            { path: 'subscription/volunteers/:id/:dest', component: VolunteerSubscriptionFormComponent },
            

            { path: 'newmember', component: NewMemberFormComponent},
            { path: 'newmember/admin', component: NewMemberFormAdminComponent,canActivate: [RoleAuthGuard], data:{requiredRoles: ['admin']} },
            
            { path: 'tutorials', component: TutorialListComponent},
            { path: 'tutorials/new', component: TuturialEditComponent},
            { path: 'tutorials/:id', component: TuturialEditComponent},
            
            
            { path: 'clothes/new', component: ClothesAdminFormComponent,canActivate: [RoleAuthGuard], data:{requiredRoles: ['admin']} },
            { path: 'clothes/edit/:id', component: ClothesAdminFormComponent,canActivate: [RoleAuthGuard], data:{requiredRoles: ['admin']} },
            { path: 'clothes/list', component: ClothesAdminListComponent,canActivate: [RoleAuthGuard], data:{requiredRoles: ['admin']} },

            { path: 'order/new', component: OrderFormComponent, canActivate: [RoleAuthGuard], data:{membersOnly:['true']}},
            { path: 'order/new/:noadmin', component: OrderFormComponent, canActivate: [RoleAuthGuard], data:{membersOnly:['true']}},
            { path: 'order/list', component: OrderListComponent, canActivate: [RoleAuthGuard], data:{requiredRoles: ['admin']} },
            { path: 'order/member', component: OrderListMemberComponent, canActivate: [RoleAuthGuard], data:{membersOnly:['true']}},

            { path: 'stock', component: StockComponent,canActivate: [RoleAuthGuard], data:{requiredRoles: ['admin']} },
            { path: 'stock-import', component: StockImportComponent,canActivate: [RoleAuthGuard], data:{requiredRoles: ['admin']} },

            { path: 'membercardcheck/:tocheck', component: MembercardCheckerComponent}, 
            { path: 'PreviewTrackComponent/:id', component: PreviewTrackComponent}, 

            { path: 'payment/:data', component: PaymentProcessingComponent}, 
            { path: 'PaymentRedirect', component: PaymentRedirectComponent}, 
            
            

            // { path: 'arrival', component: ArrivalListComponent },
            // { path: 'depart', component: DepartTimeFormComponent },
            // { path: 'agenda', component: AgendaFormComponent },
            // { path: 'tour', component: TourFormComponent },
            // { path: 'static', component: StaticPageComponent },
            { path: '**', redirectTo: 'home' }
        ]),
        MyDatePickerModule
    ],
    providers: [
        { provide: LOCALE_ID, useValue: 'nl' },
        { provide: ErrorHandler, useClass: AppErrorHandler },
        RoleAuthGuard,
        AuthGuard,
        AuthService,
        AUTH_PROVIDERS,
        MemberService,
        GroupService,
        CourseService,
        CourseriddenService,
        CalendarService,
        StaticPageService,
        AlertService,
        GeneralSettingsService,
        EventService,
        ArrivalService,
        DepartTimeService,
        AgendaService,
        TourService,
        SponsorService,
        ActivityService,
        DatePipe,
        RoundPipe,
        NewlineToHtmlPipe,
        FrontpageService,
        UploadService,
        DocumentService, 
        SubscriptionService,
        AnnouncementService,
        TutorialService,
        DiscountService,
        ClothesService,
        OrderService,
        ModuleService,
        StockService,
        NonMemberActivityService,
        PaymentService,
        VolunteerSubsriptionService,
        GroupBudgetService,
        memberPerkService
    ]
})
export class AppModuleShared {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/app.module.shared.ts